import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  public token: string = '';
  public newPassword: string = '';
  public confirmPassword: string = '';
  public loading: boolean = false;
  public resetSuccess: boolean = false;
  public resetError: string = '';
  public hideNewPassword: boolean = true;
  public hideConfirmPassword: boolean = true;
  private apiServerUrl: string = environment.apiBaseUrl;

  constructor(private route: ActivatedRoute, private http: HttpClient) {}

  ngOnInit(): void {
    // Izvuci token iz URL-a: /reset-password?token=xxx
    this.token = this.route.snapshot.queryParamMap.get('token') || '';

    if (!this.token) {
      this.resetError = 'Invalid reset link. Please request a new one.';
    }
  }

  public get passwordsMatch(): boolean {
    return this.newPassword === this.confirmPassword;
  }

  public get isFormValid(): boolean {
    return (
      !!this.newPassword &&
      !!this.confirmPassword &&
      this.passwordsMatch &&
      this.newPassword.length >= 6
    );
  }

  public onReset(): void {
    if (!this.isFormValid || !this.token) {
      return;
    }

    this.loading = true;
    this.resetError = '';

    this.http
      .post(`${this.apiServerUrl}/auth/reset-password`, {
        token: this.token,
        newPassword: this.newPassword,
      })
      .subscribe({
        next: () => {
          this.resetSuccess = true;
          this.loading = false;
        },
        error: (err) => {
          this.resetError =
            err.error?.error ||
            err.error?.message ||
            'Password reset link is invalid or has expired. Please request a new one.';
          this.loading = false;
        },
      });
  }
}
